import React from 'react'
import { Alert } from 'react-bootstrap'
import { useListCustomWorkflowRunsByEntityQuery } from '../../../store/customWorkflow/customWorkflows'
import { Spinner } from '../../Spinner/Spinner'
import { EntityWorkflowRunCard } from './EntityWorkflowRunCard'

export interface EntityWorkflowResultsProps {
  entityType: string
  entityId: string
  accountId: string
}

export const EntityWorkflowResults: React.FC<EntityWorkflowResultsProps> = ({ entityType, entityId, accountId }) => {
  const shouldSkip = !accountId || !entityType || !entityId
  const { data, isLoading, isError } = useListCustomWorkflowRunsByEntityQuery({ accountId, entityType, entityId }, { skip: shouldSkip })

  if (shouldSkip) {
    return null
  }

  if (isLoading) {
    return (
      <div className='d-flex justify-content-center pt-4'>
        <Spinner />
      </div>
    )
  }

  if (isError) {
    return (
      <Alert variant='warning' className='mb-0'>
        Could not load workflow results.
      </Alert>
    )
  }

  const runs = data?.data ?? []

  if (runs.length === 0) {
    return <p className='zocks-text-gray-600 mb-0'>No workflow results yet.</p>
  }

  return (
    <div className='d-flex flex-column zocks-gap-3'>
      {runs.map((run) => (
        <EntityWorkflowRunCard key={run.id} run={run} accountId={accountId} />
      ))}
    </div>
  )
}
